import { useEffect, useRef } from "react";

const useOutsideClick = (ref, outsideClicked, enabled = true) => {
  const callback = useRef(outsideClicked);
  callback.current = outsideClicked;
  useEffect(() => {
    if (!enabled) return;
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback.current();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, enabled]);
};

export default useOutsideClick;
